import React from 'react';

// Import all company logos statically
import BaxterLogo from '../assets/baxter-logo.png';
import DeloitteLogo from '../assets/deloitte-logo.png';
import EvernorthLogo from '../assets/evernorth-logo.png';
import HSBCLogo from '../assets/hsbc-logo.png';
import MerckLogo from '../assets/merck-logo.png';
import NCCLogo from '../assets/ncc-logo.png';
import SiemensHealthineersLogo from '../assets/siemens-healthineers-logo.png';
import StandardCharteredLogo from '../assets/standard-chartered-logo.png';
import AtlasCopcoLogo from '../assets/atlas-copco-logo.png';
import ZeptoLogo from '../assets/zepto-logo.png';
import KyndrylLogo from '../assets/kyndryl.png';
import AirIndiaExpressLogo from '../assets/airindiaexpress.png';
import SudChemieLogo from '../assets/sudchemei.png';
import GmrGroupLogo from '../assets/GMR_Group.png';
import HclHealthcareLogo from '../assets/hcl healthcare.png';
import WeberLogo from '../assets/weber.png';

const CompanyLogos = () => {
  // Map logo filenames to imported logos
  const logoMap = {
    'baxter-logo.png': BaxterLogo,
    'deloitte-logo.png': DeloitteLogo,
    'evernorth-logo.png': EvernorthLogo,
    'hsbc-logo.png': HSBCLogo,
    'merck-logo.png': MerckLogo,
    'ncc-logo.png': NCCLogo,
    'siemens-healthineers-logo.png': SiemensHealthineersLogo,
    'standard-chartered-logo.png': StandardCharteredLogo,
    'atlas-copco-logo.png': AtlasCopcoLogo,
    'zepto-logo.png': ZeptoLogo,
    'kyndryl.png': KyndrylLogo,
    'airindiaexpress.png': AirIndiaExpressLogo,
    'sudchemei.png': SudChemieLogo,
    'GMR_Group.png': GmrGroupLogo,
    'hcl healthcare.png': HclHealthcareLogo,
    'weber.png': WeberLogo,
  };

  const companyLogos = [
    'baxter-logo.png',
    'deloitte-logo.png',
    'evernorth-logo.png',
    'hsbc-logo.png',
    'merck-logo.png',
    'ncc-logo.png',
    'siemens-healthineers-logo.png',
    'standard-chartered-logo.png',
    'atlas-copco-logo.png',
    'zepto-logo.png',
    'kyndryl.png',
    'airindiaexpress.png',
    'sudchemei.png',
    'GMR_Group.png',
    'hcl healthcare.png',
    'weber.png',
  ];

  return (
    <section className="py-[80px] bg-white opacity-0 animate-fadeIn-delayed-7">
      <div className="w-[90%] max-w-[1200px] mx-auto px-5">
        <h2 className="font-heading font-semibold text-[1.8rem] relative pb-[15px] mb-12 text-[#333333] text-center">
          Attended By Leaders From
        </h2>
        
        {companyLogos.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-6 items-center justify-items-center">
            {companyLogos.map((logo, index) => {
              const logoSrc = logoMap[logo];
              if (!logoSrc) {
                console.warn(`Logo not found: ${logo}`);
                return null;
              }
              const isStandardChartered = logo === 'standard-chartered-logo.png';
              return (
                <div 
                  key={index}
                  className={`flex items-center justify-center w-full p-4 bg-white rounded-lg shadow-[0_2px_10px_rgba(0,0,0,0.05)] transition-all duration-300 hover:shadow-[0_4px_15px_rgba(107,77,196,0.15)] hover:-translate-y-1 ${isStandardChartered ? 'h-32' : 'h-24'}`}
                >
                  <img 
                    src={logoSrc} 
                    alt={`Company Logo ${index + 1}`}
                    className={`object-contain filter grayscale hover:grayscale-0 transition-all duration-300 ${isStandardChartered ? 'max-w-full max-h-full scale-125' : 'max-w-full max-h-full'}`}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-[#666666] text-lg mb-4">
              Company logos will appear here
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default CompanyLogos;
